import {
  ApiBlueprint,
  createApiFactory,
  alertApiRef,
  toastApiRef,
  type ToastApi,
  type ToastApiMessage,
  type ToastApiPostResult,
} from '@backstage/frontend-plugin-api';

export const toastStatusToAlertSeverity = (
  status?: ToastApiMessage['status'],
): 'success' | 'info' | 'warning' | 'error' => {
  switch (status) {
    case 'danger':
      return 'error';
    case 'warning':
      return 'warning';
    case 'info':
    case 'neutral':
      return 'info';
    case 'success':
    default:
      return 'success';
  }
};

export class ToastApiBridge implements ToastApi {
  private readonly alertApi: { post(alert: { message: string; severity?: string; display?: string }): void };

  constructor(alertApi: any) {
    this.alertApi = alertApi;
  }

  post(toast: ToastApiMessage): ToastApiPostResult {
    const message =
      typeof toast.title === 'string'
        ? toast.title
        : String(toast.title ?? '');

    this.alertApi.post({
      message,
      severity: toastStatusToAlertSeverity(toast.status),
      display: toast.timeout ? 'transient' : 'permanent',
    });

    return { close() {} };
  }
}

export const toastApiExtension = ApiBlueprint.make({
  name: 'toast-bridge',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: toastApiRef,
        deps: { alertApi: alertApiRef },
        factory: ({ alertApi }) => new ToastApiBridge(alertApi),
      }),
    ),
});
